import React from 'react'
import { SVGProps } from 'react'

const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.61027 12.924L6.61309 7.92115L1.68911 2.99717L3.11193 1.57435L8.03591 6.49833L12.924 1.61026L14.3897 3.07601L9.50165 7.96408L14.4256 12.8881L13.0028 14.3109L8.07883 9.3869L3.07602 14.3897L1.61027 12.924Z" />
  </svg>
)
export default CloseIcon
